import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  IFacultyClassesDetails,
  IFacultyConnect,
  IFacultyConnectDetails,
  IFacultyCourseDetails,
} from "../../../models/faculty/facultyConnect";
import { setFacultyConnectDetails } from "../../../store/slices/faculty/facultyConnectSlice";
import {
  getFacultyConnectClassDetails,
  getFacultyConnectDetails,
} from "../../../action/faculty/facultyActionCreator";
import FacultyConnectModal from "./facultyConnectModal";
import ReactModal from "react-modal";
import { setFacultyConnectClassDetails } from "../../../store/slices/faculty/facultyConnectClassSlice";
import FacultyBroadcast from "./facultyBroadcast";
import FloatingLabelDropDown from "../../../common-components/floatingdropdown";
import { suiteType } from "../../../constants/commonConstants";
import { apiConfig } from "../../../constants/apiConfig";

const FacultyConnect = (props: IFacultyConnect) => {
  const {
    getFacultyConnectDetails,
    facultyConnect,
    getFacultyClassDetails,
    facultyClass,
  } = props;
  const dispatch = useDispatch();
  const [selectedTerm, setSelectedTerm] = useState(facultyClass[0]?.id || 1);
  const [selectedCourse, setSelectedCourse] = useState(1);
  const [showConnectMailModal, setShowConnectMailModal] =
    useState<boolean>(false);
  const [toStudentMail, setToStudentMail] = useState<IFacultyConnectDetails>();
  const handleShow = (facultyConnect: IFacultyConnectDetails) => {
    setToStudentMail(facultyConnect);
    setShowConnectMailModal(true);
  };
  const handleClose = () => setShowConnectMailModal(false);
  const [showBroadcast, setShowBroadcast] = useState<boolean>(false);
  const [selectedFacultyIds, setSelectedFacultyIds] = useState<number[]>([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [toMail, setToMail] = useState<{ email: string; name: string }[]>([]);
  const [showCompose, setShowCompose] = useState<boolean>(false);
  const [suite] = useState<suiteType>(apiConfig.suite as suiteType);
  const [chat, setChat] = useState<string | undefined>("");

  useEffect(() => {
    if (suite == suiteType.google) setChat(apiConfig.googleChatUrl);
    else if (suite == suiteType.microsoft) setChat(apiConfig.teamsChatBaseUrl);
  }, []);

  const handleCourseChange = (course: number) => {
    setSelectedCourse(course);
    setSelectedFacultyIds([]);
    setToMail([]);
    setIsSelectAll(false);
    getFacultyClassDetails();
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedFacultyIds([]);
      setToMail([]);
    } else {
      setSelectedFacultyIds(facultyConnect.map((faculty) => faculty.id));
      setToMail(
        facultyConnect.map((faculty) => ({
          email: faculty.emailId,
          name: faculty.name,
        }))
      );
    }
    setIsSelectAll(!isSelectAll);
  };

  const handleOpenModal = () => toMail.length > 0 && setShowCompose(true);
  const handleCloseModal = () => setShowCompose(false);

  const handleSelectFaculty = (id: number, mailId: string, name: string) => {
    if (selectedFacultyIds.includes(id)) {
      setSelectedFacultyIds(
        selectedFacultyIds.filter((facultyId) => facultyId !== id)
      );
      setToMail(toMail.filter((facultyMail) => facultyMail.email !== mailId));
    } else {
      setSelectedFacultyIds([...selectedFacultyIds, id]);
      setToMail([...toMail, { email: mailId, name }]);
    }
  };

  useEffect(() => {
    getFacultyConnectDetails(selectedCourse);
    setSelectedFacultyIds([]);
    setToMail([]);
    setIsSelectAll(false);
    getFacultyClassDetails();
  }, [selectedCourse, selectedTerm]);

  useEffect(() => {
    return () => {
      dispatch(setFacultyConnectDetails([]));
      dispatch(setFacultyConnectClassDetails([]));
    };
  }, []);

  return (
    <>
      <div className="card-wrap h-auto comm-mobile">
        <div className="grades-wrap mb-3">
          <div className="title d-flex justify-content-start">
            <h2>Connect with your students{" - "} </h2>
            {facultyClass?.map((c: IFacultyClassesDetails, index) => (
              <div className="tabs ms-2">
                <button
                  key={index}
                  className={`${selectedTerm === c.id ? "active" : ""}`}
                  onClick={() => {
                    setSelectedTerm(c.id);
                    setSelectedCourse(
                      facultyClass.find((term) => term.id === c.id)
                        ?.classes?.[0]?.id || 1
                    );
                  }}
                >
                  {c.name}
                </button>
              </div>
            ))}
          </div>

          <div
            className={
              facultyClass.find((item) => item.id === selectedTerm)?.classes
                ?.length! > 3
                ? "tab-dropdown"
                : "tabs"
            }
          >
            {facultyClass.find((item) => item.id === selectedTerm)?.classes
              ?.length! > 3 ? (
              <FloatingLabelDropDown
                label=""
                placeholder="-Select Classes-"
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  handleCourseChange(parseInt(e.target.value))
                }
                isMandatory={false}
                value={selectedCourse}
                name="facultyClasses"
                optionsList={
                  facultyClass.find((item) => item.id === selectedTerm)
                    ?.classes || []
                }
              />
            ) : (
              facultyClass
                ?.find((item) => item.id == selectedTerm)
                ?.classes?.map(
                  (facultyCourseItem: IFacultyCourseDetails, index: number) => (
                    <button
                      key={index}
                      className={`${
                        selectedCourse === facultyCourseItem.id ? "active" : ""
                      }`}
                      onClick={() => handleCourseChange(facultyCourseItem.id)}
                    >
                      {facultyCourseItem.name}
                    </button>
                  )
                )
            )}
            <div className="broadcastwrap ms-auto">
              <button
                className="btn btn-primary active"
                onClick={() => setShowBroadcast(!showBroadcast)}
              >
                {showBroadcast ? "Close" : "Broadcast"}
              </button>
              {showBroadcast && (
                <div id="studentListDiv" className="broadcastlist">
                  <div className="title">
                    <h2 className="text-dark">Broadcast</h2>
                    <label className="checkall">
                      <input
                        type="checkbox"
                        id="checkAll"
                        checked={
                          facultyConnect.length > 0 &&
                          selectedFacultyIds.length === facultyConnect.length
                        }
                        onChange={handleSelectAll}
                      />{" "}
                      <span>Select All</span>
                    </label>
                  </div>
                  <ul id="studentList">
                    {facultyConnect?.map((faculty: IFacultyConnectDetails) => (
                      <li key={faculty.id}>
                        <label>
                          <input
                            type="checkbox"
                            name="student"
                            className="student-checkbox"
                            checked={selectedFacultyIds.includes(faculty.id)}
                            onChange={() =>
                              handleSelectFaculty(
                                faculty.id,
                                faculty.emailId,
                                faculty.name
                              )
                            }
                          />
                          <div>
                            <img
                              src={faculty.image}
                              alt={faculty.name}
                              onError={(e) => {
                                e.currentTarget.src =
                                  "/assets/images/icon/DefaultImage.jpeg";
                              }}
                            />
                            <p>{faculty.name}</p>
                          </div>
                        </label>
                      </li>
                    ))}
                  </ul>
                  <div className="sendmailwrap">
                    <button onClick={() => handleOpenModal()}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7"
                          stroke="#fff"
                          stroke-width="1.6"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
                          stroke="#fff"
                          stroke-width="1.6"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2 16.5H8"
                          stroke="#fff"
                          stroke-width="1.6"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2 12.5H5"
                          stroke="#fff"
                          stroke-width="1.6"
                          stroke-miterlimit="10"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Send Email
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          {facultyConnect?.map((facultyConnect: IFacultyConnectDetails) => (
            <div className="col-grid-5 col-lg-3">
              <div className="card-connect">
                <div
                  className={
                    facultyConnect.progress === "good"
                      ? "img attention good"
                      : facultyConnect.progress === "intermediate"
                      ? "img attention intermediate"
                      : facultyConnect.progress === "constant"
                      ? "img attention constant"
                      : "grade-not"
                  }
                >
                  <img
                    src={facultyConnect.image}
                    alt=""
                    onError={(e) => {
                      e.currentTarget.src =
                        "/assets/images/icon/DefaultImage.jpeg";
                    }}
                  />
                  <p>
                    {facultyConnect.progress === "good"
                      ? "Indicates positive academic progress."
                      : facultyConnect.progress === "intermediate"
                      ? "Indicates intermediate attention on this student."
                      : facultyConnect.progress === "constant"
                      ? "Indicates constant attention on this student"
                      : ""}
                  </p>
                </div>
                <div className="desc">
                  <h2>{facultyConnect.name}</h2>
                  <a
                    className="comm-emailid"
                    title={facultyConnect.emailId}
                    style={{ cursor: "default" }}
                  >
                    {facultyConnect.emailId}
                  </a>
                  <a style={{ cursor: "default" }}>{facultyConnect.phone}</a>
                </div>
                <div className="btns">
                  <a
                    href={chat + facultyConnect.emailId}
                    target="_blank"
                    className="con-chat"
                    title="Chat"
                  >
                    <img src="/assets/images/icon/chat.svg" alt="" />
                  </a>
                  <a
                    onClick={() => handleShow(facultyConnect)}
                    className="con-email"
                    title="Send Email"
                  >
                    <img src="/assets/images/icon/emails.svg" alt="" />
                  </a>
                  <a
                    href="staff-teams.html"
                    className="con-call disabled"
                    target="_blank"
                    title="Call"
                  >
                    <img src="/assets/images/icon/phone.svg" alt="" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <ReactModal
        isOpen={showConnectMailModal}
        onRequestClose={handleClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        style={{
          content: {
            outline: "none",
          },
        }}
      >
        <FacultyConnectModal
          setShowConnectMail={handleClose}
          toStudentMail={toStudentMail}
        />
      </ReactModal>
      <ReactModal
        isOpen={showCompose}
        onRequestClose={handleCloseModal}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <FacultyBroadcast setShowCompose={handleCloseModal} toEmails={toMail} />
      </ReactModal>
    </>
  );
};

const mapDispatchToProps = {
  getFacultyConnectDetails: (id: number) => getFacultyConnectDetails(id),
  getFacultyClassDetails: () => getFacultyConnectClassDetails(),
};

function mapStateToProps(state: any) {
  return {
    facultyConnect: state.facultyConnect.facultyConnectDetails || [],
    facultyClass: state.facultyConnectClass.facultyClassDetails || [],
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FacultyConnect);
